export function readRate(name: string, fallback: number): number {
  const raw = process.env[name];
  const n = raw !== undefined ? Number(raw) : NaN;
  if (Number.isFinite(n)) {
    if (n < 0) return 0;
    if (n > 1) return 1;
    return n;
  }
  return fallback;
}

export const sentryEnv = {
  enabled: process.env.NEXT_PUBLIC_SENTRY_ENABLED === '1',
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
  debug: process.env.NEXT_PUBLIC_SENTRY_DEBUG === '1',
  client: {
    tracesSampleRate: readRate('NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE', 0.02),
    replaysSessionSampleRate: readRate('NEXT_PUBLIC_SENTRY_REPLAYS_SESSION_SAMPLE_RATE', 0.002),
    replaysOnErrorSampleRate: readRate('NEXT_PUBLIC_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE', 1.0),
  },
  server: {
    apiTracesRate: readRate('NEXT_PUBLIC_SENTRY_API_TRACES_RATE', 1.0),
    defaultTracesRate: readRate('NEXT_PUBLIC_SENTRY_SERVER_DEFAULT_TRACES_RATE', 0.1),
  },
};


